import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { alpha, styled, useTheme } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { useState } from 'react';
import { Add } from '@mui/icons-material';

const Accordion = styled((props) => (
  <MuiAccordion
    disableGutters
    elevation={0}
    square
    {...props}
    TransitionProps={{ unmountOnExit: true }}
  />
))(({ theme }) => ({
  borderBottom: '1px solid',
  borderColor: theme.palette.primary.neutral200,
  backgroundColor: 'transparent',
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <Add sx={{ fontSize: '1.5rem', color: 'primary.neutral800' }} />
    }
    {...props}
  />
))(({ theme }) => ({
  flexDirection: 'row',
  '& .MuiAccordionSummary-root:not(:last-child)': {
    borderBottom: 0,
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
  '& .MuiTypography-root': {
    fontWeight: '500',
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  borderTop: '1px solid',
  borderColor: theme.palette.primary.neutral200,
  padding: '16px',
  paddingLeft: '24px',
  color: theme.palette.primary.neutral600,
  backgroundColor: alpha(theme.palette.primary.primarylight1, 0.16),
  '& .MuiTypography-root': {
    fontWeight: '400',
  },
}));

export default function FaqDetails() {
  const { t } = useTranslation();

  const [expanded, setExpanded] = useState();

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const faq = t('FAQ_DETAILS', { returnObjects: true }) || [];
  const theme = useTheme();
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'primary.neutral200',
        borderRadius: theme.shape.defaultBorderRadius,
        '& .MuiPaper-root:last-child': {
          borderBottom: 'none',
        },
      }}
    >
      {faq.map((item, index) => (
        <Accordion
          key={index}
          expanded={expanded === `panel${index + 1}`}
          onChange={handleChange(`panel${index + 1}`)}
        >
          <AccordionSummary
            aria-controls={`panel${index + 1}d-content`}
            id={`panel${index + 1}d-header`}
            sx={{
              '& .MuiTypography-root': {
                fontSize: '16px',
              },
            }}
          >
            <Typography variant="h2">{item.QUESTION}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body1">{item.ANSWER}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}
